// Adapter Microsoft Clarity — consome window.clarity (criado pelo componente Clarity).
// Subset curado (não firehose):
//   - custom events: somente onde meta.clarity.event === true
//     (add_to_cart, begin_checkout, purchase, upload_receita).
//   - custom tags (clarity('set', ...)): funnel_stage, forma_pagamento, tem_receita,
//     loja, cep_sem_cobertura.
import { isClarityEnabled } from "../config";

const TAG_KEYS = [
  "funnel_stage",
  "forma_pagamento",
  "tem_receita",
  "loja",
  "cep_sem_cobertura",
];

export function sendClarity(meta, payload) {
  if (!isClarityEnabled()) return;

  const clarity = window.clarity;
  const cfg = meta.clarity || {};

  if (cfg.event) {
    clarity("event", payload.event);
  }

  (cfg.tags || []).forEach((key) => {
    if (
      TAG_KEYS.includes(key) &&
      payload[key] != null &&
      payload[key] !== ""
    ) {
      clarity("set", key, String(payload[key]));
    }
  });
}

export default sendClarity;
